module.exports = __webpack_public_path__ + "img/head.abc05a3a.png";